import { simplepharmUserService } from '../../helpers/authservice/simplepharmUserService';
import { resetRbacAccessCache } from "@/helpers/rbacAccess";
import router from '../../router/index'

import { defineStore } from "pinia";
import {useNotificationStore} from "@/state/pinia/notification";
const user = JSON.parse(localStorage.getItem('user'));

export const useSimplepharmAuthModule = defineStore("simplepharmAuthModule", {
    state: () => ({
       user: user ? { status: { loggeduser: true }, user }
           : { status: {}, user: null }
    }),
    getters: {
        loggedIn(state) {
            return !!state.user
        }
    },
    actions: {
        // Logs in the user.
        login({ email, password }) {
            this.loginRequest({ email })
            const notificationStore = useNotificationStore();
            return simplepharmUserService.login(email, password)
                .then(
                    user => {
                     this.loginSuccess(user)
                        router.push('/');
                    },
                    error => {
                       this.loginFailure(error)
                        notificationStore.error(error)
                    }
                );
        },
        // Logout the user
        async logout() {
            try {
                await simplepharmUserService.logout();
            } finally {
                this.logoutUser()
                router.push('/login');
            }
        },
        // register the user
        registeruser(user) {
            const notificationStore = useNotificationStore();
            this.registerRequest()
            simplepharmUserService.register(user)
                .then(
                    user => {
                        this.registerSuccess()
                        notificationStore.success(user.message);
                        router.push('/login');
                    },
                    error => {
                        this.registerFailure(error)
                        notificationStore.error(error)
                    }
                );
        },

        //refresh JWT token
        refreshToken() {
            return simplepharmUserService.refreshToken()
                .then(
                    user => {
                        if(user.token){
                            this.loginSuccess(user)
                        }else{
                            simplepharmUserService.logout();
                           this.logout()
                            router.push('/login');
                        }

                    },
                    () => {
                        simplepharmUserService.logout();
                       this.logout()
                        router.push('/login');
                    }


                );
        },

        loginRequest( user) {
            this.status = { loggingIn: true };
            this.user = user;
        },
        loginSuccess(user) {
            this.status = { loggeduser: true };
            this.user = user;
            resetRbacAccessCache();
        },
        loginFailure() {
            this.status = {};
            this.user = null;
            resetRbacAccessCache();
        },
        logoutUser() {
            this.status = {};
            this.user = null;
            resetRbacAccessCache();
            localStorage.removeItem('user');
            localStorage.setItem('userLoggedOut', "true");
            sessionStorage.clear();
        },
        registerRequest() {
            this.status = { registering: true };
        },
        registerSuccess() {
            this.status = {};
        },
        registerFailure() {
            this.status = {};
        },

        requestPasswordReset(email) {
            const notificationStore = useNotificationStore();
            return simplepharmUserService.requestPasswordReset(email)
                .then(
                    data => {
                        notificationStore.success(data.message || 'Link do resetu hasła został wysłany na podany adres email.');
                    },
                    error => {
                        notificationStore.error(error);
                        return Promise.reject(error);
                    }
                );
        },

        confirmPasswordReset(token, newPassword) {
            const notificationStore = useNotificationStore();
            return simplepharmUserService.confirmPasswordReset(token, newPassword)
                .then(
                    data => {
                        notificationStore.success(data.message || 'Hasło zostało zmienione. Możesz się teraz zalogować.');
                    },
                    error => {
                        notificationStore.error(error);
                        return Promise.reject(error);
                    }
                );
        },
    }
});
